import {
  GET,
  DELETE,
  POST,
  POSTEXPORT,
  POSTEXPORTPDF
} from '../http'
import * as Types from './types'

export default class ReportsGateway {
  getReports () {
    return GET(Types.GET_REPORTS)
  }

  getReportsPowerBiToken (params = {}) {
    return GET(Types.REPORT_POWER_BI_TOKEN, params)
  }

  generateFinishReport (params = {}) {
    return GET(Types.GENERATE_FINISH_REPORT, params)
  }
  getReportManagerList (params = {}) {
    return GET(Types.REPORT_MANAGER_LIST, params)
  }

  getStatusReport (params = {}) {
    return GET(Types.STATUS_REPORT, params)
  }

  getBulkReports () {
    return GET(Types.GET_BULK_REPORTS)
  }

  getIndividualReports () {
    return GET(Types.GET_INDIVIDUAL_REPORTS)
  }

  getReportParameters (params = {}) {
    return GET(Types.GET_REPORT_PARAMETERS, params)
  }

  getReport (params = {}) {
    return GET(Types.GET_REPORT, params)
  }

  getGeneratedReports (params = {}) {
    return GET(Types.GET_GENERATED_REPORT, params)
  }

  saveReport (query = {}) {
    return POST(Types.SAVE_REPORT, query)
  }

  bulkReportsStop (query = {}) {
    return POST(Types.BULK_REPORTS_STOP, query)
  }

  bulkReportsClear (query = {}) {
    return POST(Types.BULK_REPORTS_CLEAR, query)
  }

  updateReport (query = {}) {
    return POST(Types.UPDATE_REPORT, query)
  }

  bulkReportsDownload (query = {}) {
    return POSTEXPORT(Types.BULK_REPORTS_DOWNLOAD, query)
  }

  bulkReportsDownloadAll (query = {}) {
    return POSTEXPORT(Types.BULK_REPORTS_DOWNLOAD_ALL, query)
  }

  bulkReportsDownloadPDF (query = {}) {
    return POSTEXPORTPDF(Types.BULK_REPORTS_DOWNLOAD, query)
  }

  bulkReportsDownloadAllPDF (query = {}) {
    return POSTEXPORTPDF(Types.BULK_REPORTS_DOWNLOAD_ALL, query)
  }

  generateReportJSON (query = {}) {
    return POST(Types.GENERATE_REPORT, query)
  }

  generateReport (query = {}) {
    return POSTEXPORT(Types.GENERATE_REPORT, query)
  }

  generateReportPDF (query = {}) {
    return POSTEXPORTPDF(Types.GENERATE_REPORT, query)
  }

  deleteReport (query = {}) {
    return DELETE(Types.DELETE_REPORT, {}, query)
  }

  sendEmailsCheck (query = {}) {
    return POST(Types.REPORT_SEND_EMAILS_CHECK, query)
  }

  previewEmails (query = {}) {
    return POST(Types.REPORT_PREVIEW_EMAILS, query)
  }

  sendEmails (query = {}) {
    return POST(Types.REPORT_SEND_EMAILS, query)
  }

  continueSendEmails (query = {}) {
    return POST(Types.REPORT_CONTINUE_SEND_EMAILS, query)
  }
}



// WEBPACK FOOTER //
// ./src/api/reports/ReportsGateway.js